import ProductCardSkeleton from '@/components/common/Skeleton/new-product-card';
import { isLatinoChannel } from '@/utils/common/latino-app';
import { twJoin } from 'tailwind-merge';

const isLatino = isLatinoChannel();
export default function ItemLineSkeleton({ showMoreLink = false }: { showMoreLink?: boolean }) {
  return (
    <div
      className="my-3"
      style={{
        minHeight: 220
      }}>
      <div className="flex items-center justify-between px-5">
        <div className="bg-surface-200-bg skeleton h-5 w-24 rounded-sm" />
        {showMoreLink && <div className="bg-surface-200-bg skeleton h-8 w-20 rounded-700" style={{ height: 31 }} />}
      </div>
      <div className="overflow-hidden">
        <div className="flex gap-1 my-100 pl-2.5">
          {Array.from({ length: 3 }).map((_item, index) => {
            return (
              <ProductCardSkeleton
                key={`skeleton-theme-list-item-${index}`}
                className={twJoin('shrink-0 grow-0', isLatino ? '!w-[130px]' : '!w-[150px]')}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
